import {useEffect, useReducer} from "react"
import {SessionContext} from "../contexts/SessionContext"
import sessionReducer from "../reducers/sessionReducer"

const initialState = {
    isLogin: false,
    idToken: null,
    idUser: null,
    idTeam: null,
    role: null,
}

export default function SessionProvider({children}) {
    const [sessionContext, setSessionAction] = useReducer(
        sessionReducer,
        initialState,
        () => {
            try {
                const stored = localStorage.getItem("sessionContext")
                return stored ? JSON.parse(stored) : initialState
            } catch (error) {
                console.error("Failed to parse sessionContext from localStorage", error)
                return initialState
            }
        }
    )

    useEffect(() => {
        if (sessionContext) {
            localStorage.setItem("sessionContext", JSON.stringify(sessionContext))
        } else {
            localStorage.removeItem("sessionContext")
        }
    }, [sessionContext])

    return (
        <SessionContext.Provider value={{sessionContext, setSessionAction}}>
            {children}
        </SessionContext.Provider>
    )
}